import React, { FC } from 'react';
import { WindowWidthContext } from '@minecraft.utils';

type Props = {
  children: JSX.Element;
};

const PublicPage: FC<Props> = ({ children }) => <>{children}</>;

export default WindowWidthContext.withWidthDataProvider(PublicPage);
